module.exports = __webpack_public_path__ + "static/media/troubleshooting.380535d5.svg";